import { getContext, setContext } from 'svelte'

const key = Symbol('booking')

/** @param {Schema.Booking} booking */
export function setBooking(booking) {
  setContext(key, booking)
}

/** @returns {Schema.Booking} */
export function getBooking() {
  return getContext(key)
}
